module.exports = __webpack_public_path__ + "img/20191209165205598.47e094df.jpg";